import { render, staticRenderFns } from "./MastheadEmbeddedBackIcon.vue?vue&type=template&id=553d0996&"
import script from "./MastheadEmbeddedBackIcon.vue?vue&type=script&lang=js&"
export * from "./MastheadEmbeddedBackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports